import { createSelector, createFeatureSelector } from '@ngrx/store';
import { GlobalState } from './global.state';

const selectGlobalState = createFeatureSelector<GlobalState>('global');

export const selectIsProcessing = createSelector(
	selectGlobalState,
	(state) => state.isProcessing
);

export const selectIsIndexing = createSelector(
	selectGlobalState,
	(state) => state.isIndexing
);

export const selectSteps = createSelector(
	selectGlobalState,
	(state) => state.steps
);

export const selectReviewSetSteps = createSelector(
	selectGlobalState,
	(state) => state.steps?.filter(step => step?.workflowName === 'SplitReviewSetWorkflow' || step?.workflowName === 'StartReviewSetWorkflow')
);

export const selectVersion = createSelector(
	selectGlobalState,
	(state) => state.version
);

export const selectUIVersion = createSelector(
	selectGlobalState,
	(state) => state.uiVersion
);

export const selectIsIndexingAndIsProcessing = createSelector(
	selectIsProcessing,
	selectIsIndexing,
	(isProcessing, isIndexing) => ({
		isProcessing,
		isIndexing
	})
);
